export enum ELikesRoutes {
  LIKES = 'Likes',
  LIKES_DETAIL = 'Likes.Detail'
}
